import { render, staticRenderFns } from "./NonIndividualTaskQueue.vue?vue&type=template&id=740367ab&scoped=true&"
import script from "./NonIndividualTaskQueue.vue?vue&type=script&lang=js&"
export * from "./NonIndividualTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./NonIndividualTaskQueue.vue?vue&type=style&index=0&id=740367ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740367ab",
  null
  
)

export default component.exports